import './index.css'
import React, { Component } from 'react'
import DocumentHeadTags from 'components/document-head-tags'
import ReferralInviteThankYouModal from 'components/modals/referral/thank-you'
import { NavigateFunction, useNavigate } from 'react-router-dom'

interface OwnProps {
  navigate: NavigateFunction
}

type Props = OwnProps

class ReferralInvite extends Component<Props> {
  _closeModal = () => {
    this.props.navigate('/')
  }

  render() {
    return (
      <div className="Referral_Modal">
        <DocumentHeadTags title="Thank you | DISCO" />
        <ReferralInviteThankYouModal onClose={this._closeModal} />
      </div>
    )
  }
}

const ReferralInviteWithRouter = (props: Omit<Props, 'navigate'>) => {
  const navigate = useNavigate()
  return <ReferralInvite {...props} navigate={navigate} />
}

export default ReferralInviteWithRouter
